import { combineReducers } from "redux";

import getComp from "./competitor";
import getMail from "./emails";
import getChannels from "./channels";
const CompReducers = combineReducers({ getComp ,getMail, getChannels});

export default CompReducers;